<template>
  <div class="dialog-container dialog-light connected-accounts">
    <div class="connected-accounts-dialog dialog dialog-md">
      <ax-dialog-header text="Connected Accounts" :type="'connect-accounts'"></ax-dialog-header>
      <div class="dialog-body">
        <div class="connected-accounts-form">
          <span>The list below is a record of all requests for data that Sinchii has run against your Xero account</span>
          <div class="mt-4 pt-2 text-center" v-show="this.tenantName">
            <span style="font-weight:bold;">Connected Organisation: {{ tenantName }}</span>
            <span>{{ (xeroConnected ? " (Active)" : " (Disconnected)") }}</span>
          </div>
          <div class="mt-4 pt-2">
            <div class="bubble white" id="xeroConnect" @click="connectToXero">
              <div class="inner">
                <div class="image">
                  <icon :type="'xero'" />
                </div>
                <div class="description">
                  <h2 class="m-0">{{ this.connectText }}</h2>
                  <p class="m-0">Made for small businesses.</p>
                </div>
                <div class="icon">
                  <i class="icon-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-center">
            <k-button
              class="btn btn-danger btn-wide"
              type="submit"
              v-if="this.xeroConnected"
              @click="disconnectXero()"
            >Disconnect Xero</k-button>
            <k-button
              class="btn btn-secondary btn-wide"
              :class="{ 'left-margin': this.xeroConnected }"
              type="submit"
              @click="showXerolog()"
            >View Logs</k-button>
          </div>
          <div class="mt-5">
            <k-button
              class="btn btn-lg btn-outline-primary w-100"
              type="submit"
              @click="close()"
            >Close</k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/auth-service";
import BusinessService from "@/services/business-service";
import icon from "../../components/Icon.vue";
import { useToast } from "vue-toastification";
import store from "../../store/index";
const toast = useToast();

export default {
  name: "connected-accounts",
  components: {
    icon
  },
  data: function () {
    return {
      connectText: "Connect to Xero",
      xeroConnected: false,
      tenantName: ""
    }
  },
  async mounted() {
    if (store.getters.isSubscriptionLocked) {
      return;
    }
    this.tenantName = store.getters.xeroTenantName;
    if (store.getters.businessID) {
      await this.getConnectedAccounts();
    }
  },
  methods: {
    async getConnectedAccounts() {
      await BusinessService.getConnectedAccounts()
      .then((response) => {
        if (response && response.connectedAccount) {
          this.xeroConnected = true;
          const option = document.getElementById("xeroConnect");
          option.classList.add("selected");
          this.connectText = "Connected with Xero";
        }
      }).catch(this.showAlert);
    },
    connectToXero() {
      if (!this.xeroConnected) {
        const scopes = "openid offline_access accounting.settings accounting.reports.read";
        AuthService.RedirectToXero(scopes);
      }
    },
    async disconnectXero() {
      await BusinessService.disconnectXero(false)
      .then((response) => {
        if (response && response.success) {
          this.xeroConnected = false;
          const option = document.getElementById("xeroConnect");
          option.classList.remove("selected");
          this.connectText = "Reconnect to Xero";
          this.showSuccess("Service disconnected successfully.");
          if (location.href.includes("cashSummary") || location.href.includes("profitLoss")) {
            setTimeout(() => {
              location = location.href;
            }, 1000);
          }
        } else {
          this.showAlert();
        }
      }).catch(this.showAlert);
    },
    showSuccess(msg) {
      toast.clear();
      toast.success(msg);
    },
    close() {
      this.$emit("closePopup");
    },
    showXerolog() {
      this.$emit("showXerolog");
    },
    showAlert() {
      toast.clear();
      toast.error("Something went wrong! Please try again.");
    }
  }
}
</script>

<style scoped>
  .left-margin {
    margin-left: 10px;
  }

</style>